// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"07b37543","977":"bb2c22a7"}[chunkId] + ".chunk.js";
};